




















































import {Component, Mixins} from 'vue-property-decorator'
import {constants} from "@/helpers/constants"
import api from "@/api/api";
import ConvertTimezone from "@/helpers/mixins/ConvertTimezone";
import Pager from "@/components/layout/Pager.vue";

@Component({
  components: {
    Pager
  }
})
export default class PointDetails extends Mixins(ConvertTimezone) {
  private REWARD_TYPE = constants.rewardEventType
  private list: object[] = []
  private pageCount = 1

  private SCORE_TYPE={
    TOTAL: -1,
    GAIN: 1,
    USED: 0
  }
  private SCORE_TYPE_MSG ={
    TOTAL: '获取/使用',
    GAIN: '只看获取',
    USED: '只看使用'
  }

  get pageSize(){
    return +this.$route.query.pageSize||20
  }
  get pageIndex(){
    return +this.$route.query.pageIndex||1
  }

  get scoreType(){
    const score = +this.$route.query.scoreType
    if(isNaN(score)){
      return -1
    }
    return score
  }

  created() {
    this.getData()
  }
  getMessage(value) {
    const Key = Object.keys(this.SCORE_TYPE).find(key => this.SCORE_TYPE[key] === value)||'TOTAL'
    return this.SCORE_TYPE_MSG[Key]
  }

  async handleReroute(value){
    await this.$router.push({path: `/myAccount/rewardPoints/pointDetails?pageSize=${this.pageSize}&pageIndex=${value}&scoreType=${this.scoreType}`})
    await this.getData()
  }

  async changeScoreType(value: number){
    await this.$router.push({path: `/myAccount/rewardPoints/pointDetails?pageSize=20&pageIndex=1&scoreType=${value}`})
    await this.getData()
  }

  async getData() {
    const query = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      scoreType: this.scoreType,
    }
    console.log({query})
    try {
      const res = await api.getRewardDetails(query)
      this.list = res.data.dataList || []
      this.pageCount = +res.data.pageCount || 1

    } catch (e) {
      console.log(e)
    }
  }
}
